import { createSlice } from '@reduxjs/toolkit';
import { GetWithToken, uploadWithToken } from '../../utils/axiosuitls';
import { _getprofile, updateprofile } from '../../utils/endpoints';
export const initialState = {
  loading: false,
  hasErrors: false,
  profile: [],
  loadingupload: false,
  hasErrorsupload: false,
  profileupload: [],
};
const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    getProfile: (state) => {
      state.loading = true;
    },
    getProfileSuccess: (state, { payload }) => {
      state.profile = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getProfileFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    updateProfile: (state) => {
      state.loadingupload = true;
    },
    updateProfileSuccess: (state, { payload }) => {
      state.profileupload = payload;
      state.loadingupload = false;
      state.hasErrors = false;
    },
    updateProfileFailure: (state) => {
      state.loadingupload = false;
      state.hasErrorsupload = true;
    },
  },
});
export const {
  getProfile,
  getProfileSuccess,
  getProfileFailure,
  updateProfile,
  updateProfileSuccess,
  updateProfileFailure,
} = profileSlice.actions;

// A selector
export const profileSelector = (state) => state.profile;

// The reducer
export default profileSlice.reducer;

// Asynchronous thunk action
export function fetchProfile() {
  return async (dispatch) => {
    dispatch(getProfile());
    try {
      await GetWithToken(_getprofile).then((response) => {
        dispatch(getProfileSuccess(response['data'].payload));
      });
    } catch (error) {
      dispatch(getProfileFailure());
    }
  };
}

export function _updateProfile(data, setAlert) {
  return async (dispatch) => {
    dispatch(updateProfile());
    try {
      await uploadWithToken(updateprofile, data).then((response) => {
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg: response.data.message,
              type: 'green',
            },
          };
        });
        dispatch(fetchProfile());
        dispatch(updateProfileSuccess(response['data'].payload));

      });
    } catch (error) {
      setAlert((prevState) => {
        return {
          ...prevState,
          ...{
            visible: true,
            msg: error.response.data.message,
            type: 'red',
          },
        };
      });
      dispatch(updateProfileFailure());
    }
  };
}